import React from 'react';
import { useBackHandler } from '../hooks/useBackHandler';

/**
 * Componente modal para visualizar imágenes de evidencia fotográfica en pantalla completa.
 * Incluye un botón flotante destacado '✕' de cerrar y soporte completo para la tecla/botón
 * de retroceso del teléfono (Android/iOS) sin salirse de la aplicación.
 */
export const ImageViewerModal = ({ src, alt = "Evidencia fotográfica", onClose }) => {
    const handleClose = useBackHandler(!!src, onClose, 'expandedImage');

    if (!src) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.92)',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '20px',
                boxSizing: 'border-box'
            }}
            onClick={handleClose}
        >
            {/* Botón Tache X de cerrar imagen */}
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                }}
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    background: '#dc3545',
                    color: '#ffffff',
                    border: '2px solid rgba(255, 255, 255, 0.9)',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    zIndex: 10001,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.6)',
                    outline: 'none'
                }}
                title="Cerrar imagen (✕)"
                aria-label="Cerrar imagen"
            >
                ✕
            </button>

            {/* Contenedor e imagen ampliada */}
            <div
                style={{
                    position: 'relative',
                    maxWidth: '95%',
                    maxHeight: '85vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
                onClick={(e) => e.stopPropagation()} // Evita cerrar al tocar la imagen
            >
                <img
                    src={src}
                    alt={alt}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '85vh',
                        objectFit: 'contain',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.7)',
                        border: '1px solid rgba(255, 255, 255, 0.15)'
                    }}
                />
            </div>

            {/* Subtítulo indicativo */}
            <div style={{
                position: 'absolute',
                bottom: '24px',
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '13px',
                fontWeight: '600',
                pointerEvents: 'none',
                background: 'rgba(0, 0, 0, 0.6)',
                padding: '6px 18px',
                borderRadius: '20px',
                border: '1px solid rgba(255,255,255,0.2)'
            }}>
                Presiona ✕ o atrás en tu teléfono para volver
            </div>
        </div>
    );
};

export default ImageViewerModal;
